export default "__VITE_ASSET__9na6$ER4__"